module.exports = "<div class=\"container-fluid mainContainer\">\n    <h1>Home</h1>\n    <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = ./src/app/home/home.component.html
// module chunks = main